import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import * as Redux from 'redux';
import { combineReducers, createStore, applyMiddleware, compose } from 'redux';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var createModels = function createModels(models) {
  return Object.keys(models).map(function (name) {
    return _extends({
      name: name
    }, models[name], {
      reducers: models[name].reducers || {}
    });
  });
};

var isObject = function isObject(obj) {
  return Array.isArray(obj) || typeof obj !== 'object';
};
/**
 * validate
 *
 * takes an array of arrays of validations and
 * throws if an error occurs
 */


var validate = function validate(validations) {
  if (process.env.NODE_ENV !== 'production') {
    for (var _iterator = validations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var validation = _ref;
      var condition = validation[0];
      var errorMessage = validation[1];

      if (condition) {
        throw new Error(errorMessage);
      }
    }
  }
};

var validateConfig = function validateConfig(config) {
  validate([[!Array.isArray(config.plugins), 'init config.plugins must be an array'], [isObject(config.models), 'init config.models must be an object'], [isObject(config.redux.reducers), 'init config.redux.reducers must be an object'], [!Array.isArray(config.redux.middlewares), 'init config.redux.middlewares must be an array'], [!Array.isArray(config.redux.enhancers), 'init config.redux.enhancers must be an array of functions'], [config.redux.combineReducers && typeof config.redux.combineReducers !== 'function', 'init config.redux.combineReducers must be a function'], [config.redux.createStore && typeof config.redux.createStore !== 'function', 'init config.redux.createStore must be a function']]);
};

var validateModel = function validateModel(model) {
  validate([[!model, 'model config is required'], [typeof model.name !== 'string', 'model "name" [string] is required'], [model.state === undefined && model.baseReducer === undefined, 'model "state" is required'], [model.baseReducer !== undefined && typeof model.baseReducer !== 'function', 'model "baseReducer" must be a function']]);
};

var validatePlugin = function validatePlugin(plugin) {
  validate([[plugin.onStoreCreated && typeof plugin.onStoreCreated !== 'function', 'Plugin onStoreCreated must be a function'], [plugin.onModel && typeof plugin.onModel !== 'function', 'Plugin onModel must be a function'], [plugin.onReducer && typeof plugin.onReducer !== 'function', 'Plugin onReducer must be a function'], [plugin.onRootReducer && typeof plugin.onRootReducer !== 'function', 'Plugin onRootReducer must be a function'], [plugin.createMiddleware && typeof plugin.createMiddleware !== 'function', 'Plugin createMiddleware must be a function']]);
};
/**
 * Dispatch Plugin
 *
 * generates dispatch[modelName][actionName]
 */


var dispatchPlugin = {
  exposed: {
    // required as a placeholder for store.dispatch
    storeDispatch: function storeDispatch() {
      console.warn('Warning: store not yet loaded');
    },
    storeGetState: function storeGetState() {
      console.warn('Warning: store not yet loaded');
    },

    /**
     * dispatch
     *
     * both a function (dispatch) and an object (dispatch[modelName][actionName])
     * @param rematch Rematch
     * @param action R.Action
     */
    dispatch: function dispatch(rematch, action) {
      return rematch.storeDispatch(action);
    },

    /**
     * createDispatcher
     *
     * generates an action creator for a given model & reducer
     * @param rematch Rematch
     * @param modelName string
     * @param reducerName string
     */
    createDispatcher: function createDispatcher(rematch, modelName, reducerName) {
      return function (payload, meta) {
        var action = {
          type: modelName + "/" + reducerName
        };

        if (typeof payload !== 'undefined') {
          action.payload = payload;
        }

        if (typeof meta !== 'undefined') {
          action.meta = meta;
        }

        return rematch.dispatch(action);
      };
    }
  },
  // access store.dispatch after store is created
  onStoreCreated: function onStoreCreated(store, rematch) {
    rematch.storeDispatch = store.dispatch;
    rematch.storeGetState = store.getState;
    store.dispatch = rematch.dispatch;
  },
  // generate action creators for all model.reducers
  onModel: function onModel(model, rematch) {
    rematch.dispatch[model.name] = {};

    if (!model.reducers) {
      return;
    }

    for (var _i = 0, _Object$keys = Object.keys(model.reducers); _i < _Object$keys.length; _i++) {
      var reducerName = _Object$keys[_i];
      rematch.validate([[!!reducerName.match(/\/.+\//), "Invalid reducer name (" + model.name + "/" + reducerName + ")"], [typeof model.reducers[reducerName] !== 'function', "Invalid reducer (" + model.name + "/" + reducerName + "). Must be a function"]]); // @ts-ignore

      rematch.dispatch[model.name][reducerName] = rematch.createDispatcher(model.name, reducerName);
    }
  }
};
/**
 * Effects Plugin
 *
 * Plugin for handling async actions
 */

var effectsPlugin = {
  exposed: {
    // expose effects for access from dispatch plugin
    effects: {}
  },
  // add effects to dispatch so that dispatch[modelName][effectName] calls an effect
  onModel: function onModel(model, rematch) {
    if (!model.effects) {
      return;
    }

    var effects = typeof model.effects === 'function' ? model.effects(rematch.dispatch) : model.effects;

    for (var _i = 0, _Object$keys = Object.keys(effects); _i < _Object$keys.length; _i++) {
      var effectName = _Object$keys[_i];
      rematch.validate([[!!effectName.match(/\//), "Invalid effect name (" + model.name + "/" + effectName + ")"], [typeof effects[effectName] !== 'function', "Invalid effect (" + model.name + "/" + effectName + "). Must be a function"]]);
      rematch.effects[model.name + "/" + effectName] = effects[effectName].bind(rematch.dispatch[model.name]); // add effect to dispatch
      // is assuming dispatch is available already... that the dispatch plugin is in there
      // @ts-ignore

      rematch.dispatch[model.name][effectName] = rematch.createDispatcher(model.name, effectName); // tag effects so they can be differentiated from normal actions
      // @ts-ignore

      rematch.dispatch[model.name][effectName].isEffect = true;
    }
  },
  // process async/await actions
  createMiddleware: function createMiddleware(rematch) {
    return function (store) {
      return function (next) {
        return function (action) {
          // async/await acts as promise middleware
          if (action.type in rematch.effects) {
            // run first reducer action if exists
            next(action);
            return rematch.effects[action.type](action.payload, store.getState(), action.meta);
          }

          return next(action);
        };
      };
    };
  }
};
var corePlugins = [dispatchPlugin, effectsPlugin];

function initializePlugin(rematch, plugin) {
  validatePlugin(plugin);

  if (plugin.onInit) {
    plugin.onInit(rematch);
  } // add exposed to rematch class


  if (plugin.exposed) {
    var _loop = function _loop() {
      var key = _Object$keys[_i];
      rematch[key] = typeof plugin.exposed[key] === 'function' ? function () {
        var _plugin$exposed;

        for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
          params[_key] = arguments[_key];
        }

        return (// insert rematch as the first argument of exposed function
          (_plugin$exposed = plugin.exposed)[key].apply(_plugin$exposed, [rematch].concat(params))
        );
      } : Object.create(plugin.exposed[key]);
    };

    for (var _i = 0, _Object$keys = Object.keys(plugin.exposed); _i < _Object$keys.length; _i++) {
      _loop();
    }
  }
}

function createPlugins(rematch, userPlugins) {
  var plugins = [];

  for (var _iterator = corePlugins.concat(userPlugins), _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i2 >= _iterator.length) break;
      _ref = _iterator[_i2++];
    } else {
      _i2 = _iterator.next();
      if (_i2.done) break;
      _ref = _i2.value;
    }

    var plugin = _ref;
    initializePlugin(rematch, plugin);
    plugins.push(plugin);
  }

  return plugins;
}
/**
 * isListener
 *
 * determines if an action is a listener on another model
 */


var isListener = function isListener(reducer) {
  return reducer.indexOf('/') > -1;
};

var composeEnhancersWithDevtools = function composeEnhancersWithDevtools(devtoolOptions) {
  if (devtoolOptions === void 0) {
    devtoolOptions = {};
  }

  var _devtoolOptions = devtoolOptions,
      disabled = _devtoolOptions.disabled,
      options = _objectWithoutPropertiesLoose(_devtoolOptions, ["disabled"]);
  /* istanbul ignore next */

  /* eslint-disable no-underscore-dangle */


  return !disabled && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(options) : compose;
};

function createRematchStore(rematch) {
  var redux = rematch.config.redux;
  var combineReducers$1 = redux.combineReducers || combineReducers;
  var createStore$1 = redux.createStore || createStore;
  var initialState = typeof redux.initialState !== 'undefined' ? redux.initialState : {}; // combine models to generate reducers

  var mergeReducers = function mergeReducers() {
    if (!Object.keys(rematch.reducers).length) {
      // no reducers, just return state
      return function (state) {
        return state;
      }; // eslint-disable-line @typescript-eslint/no-explicit-any
    }

    return combineReducers$1(rematch.reducers);
  };

  var createModelReducer = function createModelReducer(model) {
    var modelBaseReducer = model.baseReducer;
    var modelReducers = {};

    for (var _i = 0, _Object$keys = Object.keys(model.reducers || {}); _i < _Object$keys.length; _i++) {
      var modelReducer = _Object$keys[_i];
      var action = isListener(modelReducer) ? modelReducer : model.name + "/" + modelReducer;
      modelReducers[action] = model.reducers[modelReducer];
    }

    var combinedReducer = function combinedReducer(state, action) {
      if (state === void 0) {
        state = model.state;
      }

      if (typeof modelReducers[action.type] === 'function') {
        return modelReducers[action.type](state, action.payload, action.meta);
      }

      return state;
    };

    var reducer = !modelBaseReducer ? combinedReducer : function (state, action) {
      return combinedReducer(modelBaseReducer(state, action), action);
    };
    rematch.forEachPlugin('onReducer', function (onReducer) {
      reducer = onReducer(reducer, model.name, rematch) || reducer;
    });
    rematch.reducers[model.name] = reducer;
  };

  var createRootReducer = function createRootReducer() {
    var rootReducers = redux.rootReducers;
    var mergedReducers = mergeReducers();
    var rootReducer = mergedReducers;

    if (rootReducers && Object.keys(rootReducers).length) {
      rootReducer = function rootReducer(state, action) {
        var rootReducerAction = rootReducers[action.type];

        if (rootReducers[action.type]) {
          return mergedReducers(rootReducerAction(state, action), action);
        }

        return mergedReducers(state, action);
      };
    }

    rematch.forEachPlugin('onRootReducer', function (onRootReducer) {
      rootReducer = onRootReducer(rootReducer, rematch) || rootReducer;
    });
    return rootReducer;
  }; // initialize model reducers


  for (var _iterator = rematch.models, _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i2 >= _iterator.length) break;
      _ref = _iterator[_i2++];
    } else {
      _i2 = _iterator.next();
      if (_i2.done) break;
      _ref = _i2.value;
    }

    var model = _ref;
    createModelReducer(model);
  }

  var rootReducer = createRootReducer();
  var middlewares = applyMiddleware.apply(Redux, redux.middlewares);
  var enhancers = composeEnhancersWithDevtools(redux.devtoolOptions).apply(void 0, redux.enhancers.concat([middlewares]));
  var store = createStore$1(rootReducer, initialState, enhancers);
  return _extends({
    name: rematch.config.name
  }, store, {
    // dynamic loading of models with `replaceReducer`
    model: function model(_model) {
      rematch.addModels([_model]);
      createModelReducer(_model);
      store.replaceReducer(createRootReducer());
      store.dispatch({
        type: '@@redux/REPLACE '
      });
    }
  });
}

var Rematch =
/*#__PURE__*/
function () {
  function Rematch(config) {
    this.config = config;
    this.validate = validate;
    this.reducers = config.redux.reducers;
    this.plugins = createPlugins(this, config.plugins);
    this.collectMiddlewaresFromPlugins();
    this.models = createModels(config.models);
    this.addModels(this.models);
  }

  var _proto = Rematch.prototype;

  _proto.collectMiddlewaresFromPlugins = function collectMiddlewaresFromPlugins() {
    var _this = this;

    this.forEachPlugin('createMiddleware', function (createMiddleware) {
      _this.config.redux.middlewares.push(createMiddleware(_this));
    });
  };

  _proto.addModels = function addModels(models) {
    var _this2 = this;

    var _loop = function _loop() {
      if (_isArray) {
        if (_i >= _iterator.length) return "break";
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) return "break";
        _ref = _i.value;
      }

      var model = _ref;
      validateModel(model);

      _this2.forEachPlugin('onModel', function (onModel) {
        return onModel(model, _this2);
      });
    };

    for (var _iterator = models, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      var _ret = _loop();

      if (_ret === "break") break;
    }
  };

  _proto.createStore = function createStore() {
    var _this3 = this;

    var rematchStore = createRematchStore(this);
    this.forEachPlugin('onStoreCreated', function (onStoreCreated) {
      rematchStore = onStoreCreated(rematchStore, _this3) || rematchStore;
    });
    return rematchStore;
  };

  _proto.forEachPlugin = function forEachPlugin(method, fn) {
    for (var _iterator2 = this.plugins, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var plugin = _ref2;

      if (plugin[method]) {
        fn(plugin[method]);
      }
    }
  };

  return Rematch;
}();

var merge = function merge(original, next) {
  return next ? _extends({}, next, {}, original || {}) : original || {};
};
/**
 * mergeConfig
 *
 * merge init configs together
 */


var mergeConfig = function mergeConfig(initConfig) {
  var config = _extends({
    name: initConfig.name,
    models: {},
    plugins: []
  }, initConfig, {
    redux: _extends({
      reducers: {},
      rootReducers: {},
      enhancers: [],
      middlewares: []
    }, initConfig.redux, {
      devtoolOptions: _extends({
        name: initConfig.name
      }, initConfig.redux && initConfig.redux.devtoolOptions ? initConfig.redux.devtoolOptions : {})
    })
  });

  validateConfig(config); // defaults

  for (var _iterator = config.plugins, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var plugin = _ref;

    if (plugin.config) {
      // models
      config.models = merge(config.models, plugin.config.models); // plugins

      config.plugins = [].concat(config.plugins, plugin.config.plugins || []); // redux

      if (plugin.config.redux) {
        config.redux.initialState = merge(config.redux.initialState, plugin.config.redux.initialState);
        config.redux.reducers = merge(config.redux.reducers, plugin.config.redux.reducers);
        config.redux.rootReducers = merge(config.redux.rootReducers, plugin.config.redux.reducers);
        config.redux.enhancers = [].concat(config.redux.enhancers, plugin.config.redux.enhancers || []);
        config.redux.middlewares = [].concat(config.redux.middlewares, plugin.config.redux.middlewares || []);
        config.redux.combineReducers = config.redux.combineReducers || plugin.config.redux.combineReducers;
        config.redux.createStore = config.redux.createStore || plugin.config.redux.createStore;
      }
    }
  }

  return config;
};
/**
 * global createModel
 *
 * creates a model for the given object
 * this is for autocomplete purposes only
 * returns the same object that was received as argument
 */


function createModel(model) {
  return model;
} // incrementer used to provide a store name if none exists


var count = 0;
/**
 * init
 *
 * generates a Rematch store
 * with a set configuration
 * @param initConfig
 */

var init = function init(initConfig) {
  if (initConfig === void 0) {
    initConfig = {};
  }

  var name = initConfig.name || count.toString();
  count += 1;
  var config = mergeConfig(_extends({}, initConfig, {
    name: name
  }));
  return new Rematch(config).createStore();
};

var index = {
  init: init
};
export default index;
export { createModel, init };